<template>
  <div class="grid scroll-div">
    <div class="grid-title bg-primary">
      <h4 class="text-bold text-white">Top 10 Popular Fabrics</h4>
    </div>
    <div class="grid-body p-0">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th class="pointer" @click="sort('fabric_id')">
              Fabric
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="text-center pointer" @click="sort('rating')">
              Rank
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fabric, index) in sortedFabrics" :key="index">
            <td>
              <router-link :to="'/fabric/update/' + fabric.fabric_id">
                {{ $Fabric.getCode(fabric.fabric_id) }} - {{ fabric.name }}
              </router-link>
            </td>
            <td class="text-center">{{ fabric.rating }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pageData"],
  data() {
    return {
      sortType: "asc",
      sortedFabrics: [],
    };
  },
  methods: {
    sort(column) {
      this.sortType = this.sortType == "asc" ? "desc" : "asc";
      this.sortedFabrics = _.orderBy(
        this.sortedFabrics,
        [column],
        [this.sortType]
      );
    },
  },
  watch: {
    "pageData.popularFabrics": function () {
      let popularFabrics = this.pageData.popularFabrics;
      if (popularFabrics) {
        var rank = 1;
        for (var i = 0; i < popularFabrics.length; i++) {
          // increase rank only if current score less than previous
          if (
            i > 0 &&
            popularFabrics[i - 1].fabric_usage > popularFabrics[i].fabric_usage
          ) {
            rank++;
          }
          popularFabrics[i].rating = rank;
        }
        this.sortedFabrics = popularFabrics;
      }
    },
  },
};
</script>
